// --- frontend/components/Footer.jsx ---
import React from 'react';

function Footer() {
  return (
    <footer className="bg-light text-center py-4 text-sm text-primary font-cormorant">
      &copy; {new Date().getFullYear()} Cantrysa LLC - All Rights Reserved.
    </footer>
  );
}

export default Footer;